import React from 'react';

// constants
import { layoutModeTypes } from "../../Components/constants/layout";

const LightDark = ({ layoutMode, onChangeLayoutMode, onChangeTextColorMode }) => {
    const mode = layoutMode === layoutModeTypes['DARKMODE'] ? layoutModeTypes['LIGHTMODE'] : layoutModeTypes['DARKMODE'];

    const toggleWhiteMode = () => {
        onChangeTextColorMode(); 
        onChangeLayoutMode(mode);
    }

    return (
        <div className="ms-1 header-item d-none d-sm-flex">
            <button
                onClick={toggleWhiteMode} 
                type="button" className="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle light-dark-mode">
                <i className='bx bx-moon fs-22'></i>
            </button>
        </div>
    );
};

export default LightDark;
